// @flow

export { default as BankProductsTable } from './BankProductsTable';
